import { createContext } from 'react';

export const TimezoneContext = createContext<string>('Europe/Rome');
